module.exports = __webpack_public_path__ + "img/sales1.5fd361a7.jpg";